import script from "./ExamScheduleTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamScheduleTable.vue?vue&type=script&setup=true&lang=js"

import "./ExamScheduleTable.vue?vue&type=style&index=0&id=44306594&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44306594"]])

export default __exports__